import { EventSearchForm } from '@mark43/cad-api';
import { SearchableLocationFilterSummary } from '../search-windows/searchable-location-filter-summary';

export function EventLocationFiltersSummary({
    eventSearchForm,
}: {
    eventSearchForm: EventSearchForm;
}) {
    return (
        <SearchableLocationFilterSummary
            title="Event Location"
            location={eventSearchForm.locations[0]}
            locationVerification={eventSearchForm.locationVerification}
            polygonPoints={eventSearchForm.polygonPoints}
        />
    );
}
